import React from 'react';
import styled from 'styled-components';

const LUMA_URL = 'https://luma.com/calendar/cal-Ls0IG5Ekf040KLt';
const RETRO_TV_URL = 'https://90s.myretrotvs.com/#W8NjXQMYIEQ';

function EventPrompt({ onClose }) {
  function handleYes() {
    window.open(LUMA_URL, '_blank', 'noopener,noreferrer');
  }

  function handleNo() {
    window.open(RETRO_TV_URL, '_blank', 'noopener,noreferrer');
    window.dispatchEvent(new CustomEvent('spawnVirusAds'));
  }

  return (
    <Wrap>
      <Message>Subscribe to our Luma</Message>
      <Buttons>
        <Button type="button" onClick={handleYes}>
          Join
        </Button>
        <Button type="button" onClick={handleNo}>
          Later
        </Button>
      </Buttons>
    </Wrap>
  );
}

const Wrap = styled.div`
  padding: 16px;
  font-family: Tahoma, sans-serif;
  background: linear-gradient(to bottom, #ffd54f 0%, #ff8f00 50%, #e65100 100%);
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
`;

const Message = styled.p`
  margin: 0;
  font-size: 15px;
  font-weight: bold;
  line-height: 1.4;
  text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.5),
    -1px -1px 0 rgba(0, 0, 0, 0.2);
  color: #1a1a1a;
`;

const Buttons = styled.div`
  display: flex;
  gap: 10px;
`;

const Button = styled.button`
  min-width: 84px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  font-family: Tahoma, sans-serif;
  color: #fff;
  background: linear-gradient(to bottom, #3b82f6 0%, #2563eb 100%);
  border: 1px solid #1d4ed8;
  border-right-color: #1e40af;
  border-bottom-color: #1e40af;
  box-shadow: 1px 1px 0 rgba(255,255,255,0.3) inset, -1px -1px 0 rgba(0,0,0,0.2) inset;
  transition: background 120ms ease-out, transform 100ms ease-out;
  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background: linear-gradient(to bottom, #60a5fa 0%, #3b82f6 100%);
    }
  }
  &:active {
    transform: scale(0.97);
    background: linear-gradient(to bottom, #1d4ed8 0%, #1e40af 100%);
  }
`;

export default EventPrompt;
